import { getUrl } from 'scripts/adapters/lib/url';
import GuidePerformanceView from 'models/location/guide_performance_view';
import OpenGuidePerformance from 'actions/guide_performance/open_guide_performance';
import { registerUrlConverter } from './location_url';
import UnloadGuidePerformance from 'actions/guide_performance/unload_guide_performance';

registerUrlConverter(GuidePerformanceView, {
  generateUrl: (path, params) => {
    return getUrl(path, params, { arrayFormat: 'comma' });
  },
  getPath: () => '/guide-performance',
  getQueryParams: location => {
    const params = {};
    if (location.dateRange) {
      params.d = location.dateRange;
    }
    if (location.guideCollectionId) {
      params.gid = location.guideCollectionId;
    }
    if (location.interactionType) {
      params.c = location.interactionType;
    }
    if (location.sort) {
      params.sk = location.sort.key;
      params.sd = location.sort.direction;
    }
    if (location.pageNumber && location.pageNumber !== 1) {
      params.page = location.pageNumber;
    }
    return params;
  },
});

export default function (router, { runnerContext }) {
  return {
    on: () => {
      const queryParams = router.parseQueryParameters().toJS();
      let attr = {};
      if (queryParams.d) {
        attr.dateRange = queryParams.d;
      }
      if (queryParams.gid) {
        attr.guideCollectionId = queryParams.gid;
      }
      if (queryParams.c) {
        attr.interactionType = queryParams.c;
      }
      if (queryParams.sk) {
        attr.sort = { key: queryParams.sk, direction: queryParams.sd };
      }
      if (queryParams.page) {
        attr.pageNumber = parseInt(queryParams.page, 10);
      }

      runnerContext.executeAction(OpenGuidePerformance, attr);
    },
    after() {
      runnerContext.executeAction(UnloadGuidePerformance);
    },
  };
}
